module.exports = __webpack_public_path__ + "static/media/compare_icon.ce3447bc.svg";